import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestWorkspaceUserCreditsLimitUpdateStatus } from '@shared/dto/+workspace/workspace_user/_requests/request_workspace_user_credits_limit_update_status';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__workspace } from '../STATE__workspace';

export const remote_workspace_user_credits_limit_update_status = createAsyncThunkSafe<void, RequestWorkspaceUserCreditsLimitUpdateStatus>(
  ENUM__network_event_client_to_server.WORKSPACE_USER_USER_CREDITS_LIMIT_UPDATE_STATUS,
  async (request): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORKSPACE_USER_USER_CREDITS_LIMIT_UPDATE_STATUS, request);
  },
);

export function init_remote_workspace_user_credits_limit_update_status(builder: ActionReducerMapBuilder<STATE__workspace>) {
  builder
    .addCase(remote_workspace_user_credits_limit_update_status.pending, (state, action) => {})
    .addCase(remote_workspace_user_credits_limit_update_status.rejected, (state, action) => {})
    .addCase(remote_workspace_user_credits_limit_update_status.fulfilled, (state, action: PayloadAction) => {});
}
